import { createContext } from 'react';

const HabitIconCatalogContext = createContext({
  icons: [],
});

export default HabitIconCatalogContext;
